import _ from "lodash";

const displaySection = (fieldsToDisplay, steps, updatedProgress) => {
  let newSteps = [];
  let stepsChanged = false;
  _.map(steps, (s) => {
    let match = _.filter(fieldsToDisplay, (field) => field === s?.name);
    if (match?.length > 0 && s.ishidden === 1) {
      s.ishidden = 0;
      stepsChanged = true;
    }
    newSteps.push(s);
  });

  if (newSteps.length > 0 && stepsChanged === true) {
    // console.log("called......... display");
    updatedProgress(newSteps);
  }
};

const hideSection = (name, steps, updatedProgress) => {
  let newSteps = [];
  let stepsChanged = false;
  _.map(steps, (s) => {
    if (s?.name === name && s.ishidden === 0) {
      s.ishidden = 1;
      stepsChanged = true;
    }
    newSteps.push(s);
  });

  if (newSteps.length > 0 && stepsChanged === true) {
    // console.log("called......... hidden");
    updatedProgress(newSteps);
  }
};

const clearFormFields = (field, autofill) => {
  let blankVal = null;

  // console.log("field name for clear :- ", field);

  autofill(field, blankVal);
};

const clearSectionFields = (
  name,
  fieldsToDisplay,
  allConditionalFields,
  formValues,
  autofill,
  sectionArray,
  steps,
  updatedProgress
) => {
  // Check if this section is allowed to display, then do not clear its child elements and do not hide
  let sectionAllowed = _.indexOf(fieldsToDisplay, name);

  // Get this section field's all child fields
  let match = _.filter(sectionArray, (obj) => {
    return obj.name === name;
  });

  if (match?.length > 0 && sectionAllowed < 0) {
    let childFields = match?.[0]?.elements;

    hideSection(name, steps, updatedProgress);

    _.map(childFields, (obj) => {
      let f = obj?.name;
      if (formValues?.[f]) {
        clearFormFields(f, autofill); // Clear the child fields
      }

      // Check this field has conditional fields or not
      let match = _.filter(allConditionalFields, (obj) => {
        return obj.name === f;
      });

      if (match.length > 0) {
        clearReleatedFields(
          f,
          fieldsToDisplay,
          allConditionalFields,
          formValues,
          autofill,
          sectionArray,
          steps,
          updatedProgress
        ); // Call function to clear its child data
      }
    });
  }
};

const clearReleatedFields = (
  name,
  fieldsToDisplay,
  allConditionalFields,
  formValues,
  autofill,
  sectionArray,
  steps,
  updatedProgress
) => {
  // Get this field all conditional fields
  let match = _.filter(allConditionalFields, (obj) => {
    return obj.name === name;
  });

  if (match.length > 0) {
    let options = match?.[0]?.options;

    let allRelatedFields = [];
    _.map(options, (obj) => {
      let split = obj?.displayfields ? obj?.displayfields?.split(",") : [];
      allRelatedFields = _.concat(allRelatedFields, split);
    });
    allRelatedFields = _.uniq(allRelatedFields);

    // check if child conditional field have the name, which is allowed by the parent to display, then remove that field from child conditional fields options.
    let allFields = _.difference(allRelatedFields, fieldsToDisplay);

    allFields.forEach((f) => {
      if (formValues?.[f]) {
        clearFormFields(f, autofill); // Clear the child fields
      }

      // Check this field has conditional fields or not
      let match = _.filter(allConditionalFields, (obj) => {
        return obj.name === f;
      });

      if (match.length > 0) {
        clearReleatedFields(
          f,
          fieldsToDisplay,
          allConditionalFields,
          formValues,
          autofill
        ); // Call self function to clear its child data
      }

      // Check if this is section field. then clear its all child elements and hide the section
      let checksection = _.filter(
        sectionArray,
        (section) => section?.name === f
      );
      // console.log("checksection :- ", f, checksection);

      if (checksection?.length > 0) {
        clearSectionFields(
          f,
          fieldsToDisplay,
          allConditionalFields,
          formValues,
          autofill,
          sectionArray,
          steps,
          updatedProgress
        ); // Call this function to clear its all child fields
      }
    });
  }
};

export const handleShowHide = (
  name,
  formValues,
  autofill,
  lastFieldUpdated,
  allConditionalFields,
  sectionArray = [], // this is for section wise display checkout
  steps = [], // this is for section wise display checkout
  updatedProgress = null // this is for section wise display checkout
) => {
  let ishidden = 0;
  // console.log("allConditionalFields :- ", allConditionalFields);
  // console.log("sectionArray :- ", sectionArray);
  // console.log("steps------- :- ", steps);
  // console.log("formValues :- ", formValues);

  let fieldInsideCondition = [];
  for (let index = 0; index < allConditionalFields.length; index++) {
    let item = allConditionalFields[index];
    let options = item.options;

    let isCondition = false;
    _.forEach(options, (val) => {
      if (val?.displayfields.indexOf(name) > -1) {
        isCondition = true;
      }
    });

    if (isCondition) {
      fieldInsideCondition.push(item);
    }
  }
  // console.log("fieldInsideCondition :- ", name, fieldInsideCondition);

  // Check is this conditional field
  let checkChoditional = _.filter(allConditionalFields, (val) => {
    return val?.name === name;
  });
  // console.log("checkChoditional :- ", name, checkChoditional);

  if (fieldInsideCondition?.length > 0 || checkChoditional?.length > 0) {
    if (fieldInsideCondition?.length > 0) {
      // console.log("Inside Conditional .................");
      ishidden = 1;

      for (let index = 0; index < fieldInsideCondition.length; index++) {
        let item = fieldInsideCondition[index];
        let fName = item.name;
        let fKey = item.key;
        let options = item.options;

        let fieldsToDisplay = [];
        let fieldsToHide = [];
        if (formValues?.[fName]) {
          let selVal = formValues?.[`${fName}`];
          if (fKey === "dropdown") {
            let checkType = typeof formValues?.[`${fName}`];

            if (checkType === "object") {
              selVal = formValues?.[`${fName}`]?.value ?? "";
            }
          }
          // console.log("selected val :- ", selVal, item);

          // Get all unique conditional fields of this options.
          let allUniqueFields = [];
          _.map(options, (obj) => {
            let split = obj?.displayfields
              ? obj?.displayfields?.split(",")
              : [];
            allUniqueFields = _.concat(allUniqueFields, split);
          });
          allUniqueFields = _.uniq(allUniqueFields);

          if (fKey === "checkboxes") {
            // For selected option related child that we need to display
            _.map(selVal, (val) => {
              let matchR = _.filter(options, (o) => o?.value === val);
              if (matchR.length > 0) {
                let split = matchR?.[0]?.displayfields
                  ? matchR?.[0]?.displayfields?.split(",")
                  : [];
                fieldsToDisplay = _.concat(fieldsToDisplay, split);
              }
            });
            fieldsToDisplay = _.uniq(fieldsToDisplay);

            // For selected field other option related child that we need to hide
            fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
          } else {
            // For selected option related child that we need to display
            let matchR = _.filter(options, (o) => {
              return o.value === selVal;
            });

            if (matchR.length > 0) {
              let split = matchR?.[0]?.displayfields
                ? matchR?.[0]?.displayfields?.split(",")
                : [];
              fieldsToDisplay = split;
              fieldsToDisplay = _.uniq(fieldsToDisplay);
            }

            // For selected field other option related child that we need to hide
            fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
          }

          // console.log("fieldsToHide :- ", fName, fieldsToHide);
          // Clear the selected field's other options field data
          if (fieldsToHide.length > 0 && lastFieldUpdated === fName) {
            fieldsToHide.forEach((f) => {
              if (formValues?.[f]) {
                // console.log("in........ clear");
                clearFormFields(f, autofill); // Clear the child fields
              }

              // Check this field has conditional fields or not
              let match = _.filter(allConditionalFields, (obj) => {
                return obj.name === f;
              });

              if (match.length > 0) {
                clearReleatedFields(
                  f,
                  fieldsToDisplay,
                  allConditionalFields,
                  formValues,
                  autofill,
                  sectionArray,
                  steps,
                  updatedProgress
                ); // Call function to clear its child data
              }

              // Check if this is section field. then clear its all child elements and hide the section
              let checksection = _.filter(
                sectionArray,
                (section) => section?.name === f
              );
              // console.log("checksection :- ", f, checksection);

              if (checksection?.length > 0) {
                clearSectionFields(
                  f,
                  fieldsToDisplay,
                  allConditionalFields,
                  formValues,
                  autofill,
                  sectionArray,
                  steps,
                  updatedProgress
                );
              }
            });
          }

          // console.log("fieldsToDisplay :- ", fName, fieldsToDisplay);
          // Display the selected field option field data
          if (fieldsToDisplay.length > 0) {
            let displyCheck = fieldsToDisplay.indexOf(name) >= 0;

            // Call this method to update the display section redux
            displaySection(fieldsToDisplay, steps, updatedProgress);

            if (displyCheck === true) {
              ishidden = 0;
            }
          }
        }

        if (ishidden === 0) {
          // console.log("break called...........................", name);

          break;
        }
      }
    } else {
      // This is field of section page and if its hasConditional field (For Section wise display page which will display or hids the section)
      // Logic to check is this section wise page layout form
      let isFieldOK = false;
      if (steps?.length > 0) {
        let check = _.filter(steps, (s) => s.status === "complete");
        // console.log("check :- ", check);

        if (check?.length > 0) {
          // Check the current step index
          let currentIndex = _.findIndex(steps, (s) => {
            return s.status === "current";
          });
          // console.log("currentIndex :- ", currentIndex);

          // Get the current step section all elements details
          let currentSection = sectionArray[currentIndex - 1].elements;
          // console.log("currentSection :- ", currentSection);
          // let lastField = _.last(currentSection);
          let checkFiled = _.filter(currentSection, (obj) => obj.name === name);

          // if (lastField?.name === name) {
          //   isFieldOK = true;
          // }

          if (checkFiled.length > 0) {
            isFieldOK = true;
          }
        }
      }
      if (checkChoditional?.length > 0 && isFieldOK === true) {
        // console.log("Only Conditional .................");
        let item = checkChoditional[0];
        let fName = item.name;
        let fKey = item.key;
        let options = item.options;
        let fieldsToDisplay = [];
        let fieldsToHide = [];
        if (formValues?.[fName]) {
          let selVal = formValues?.[fName];
          if (fKey === "dropdown") {
            let checkType = typeof formValues?.[`${fName}`];
            if (checkType === "object") {
              selVal = formValues?.[`${fName}`]?.value ?? "";
            }
          }
          // console.log("selected val :- ", selVal, item);
          // Get all unique conditional fields of this options.
          let allUniqueFields = [];
          _.map(options, (obj) => {
            let split = obj?.displayfields
              ? obj?.displayfields?.split(",")
              : [];
            allUniqueFields = _.concat(allUniqueFields, split);
          });
          allUniqueFields = _.uniq(allUniqueFields);
          if (fKey === "checkboxes") {
            // For selected option related child that we need to display
            _.map(selVal, (val) => {
              let matchR = _.filter(options, (o) => o?.value === val);
              if (matchR.length > 0) {
                let split = matchR?.[0]?.displayfields
                  ? matchR?.[0]?.displayfields?.split(",")
                  : [];
                fieldsToDisplay = _.concat(fieldsToDisplay, split);
              }
            });
            fieldsToDisplay = _.uniq(fieldsToDisplay);
            // For selected field other option related child that we need to hide
            fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
          } else {
            // For selected option related child that we need to display
            let matchR = _.filter(options, (o) => {
              return o.value === selVal;
            });
            if (matchR.length > 0) {
              let split = matchR?.[0]?.displayfields
                ? matchR?.[0]?.displayfields?.split(",")
                : [];
              fieldsToDisplay = split;
              fieldsToDisplay = _.uniq(fieldsToDisplay);
            }
            // For selected field other option related child that we need to hide
            fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
          }
          // console.log("fieldsToHide :- ", fName, fieldsToHide);
          // Clear the selected field's other options field data
          if (fieldsToHide.length > 0 && lastFieldUpdated === fName) {
            fieldsToHide.forEach((f) => {
              // if (formValues?.[f]) {
              //   // console.log("in........ clear");
              //   clearFormFields(f, autofill); // Clear the child fields
              // }
              // // Check this field has conditional fields or not
              // let match = _.filter(allConditionalFields, (obj) => {
              //   return obj.name === f;
              // });
              // if (match.length > 0) {
              //   clearReleatedFields(
              //     f,
              //     fieldsToDisplay,
              //     allConditionalFields,
              //     formValues,
              //     autofill,
              //     sectionArray,
              //     steps,
              //     updatedProgress
              //   ); // Call function to clear its child data
              // }

              // Check if this is section field. then clear its all child elements and hide the section
              let checksection = _.filter(
                sectionArray,
                (section) => section?.name === f
              );
              // console.log("checksection :- ", f, checksection);
              if (checksection?.length > 0) {
                clearSectionFields(
                  f,
                  fieldsToDisplay,
                  allConditionalFields,
                  formValues,
                  autofill,
                  sectionArray,
                  steps,
                  updatedProgress
                );
              }
            });
          }
          // console.log("fieldsToDisplay :- ", fName, fieldsToDisplay);
          // Display the selected field option field data
          if (fieldsToDisplay.length > 0) {
            // let displyCheck = fieldsToDisplay.indexOf(name) >= 0;

            // Call this method to update the display section redux
            displaySection(fieldsToDisplay, steps, updatedProgress);
            // if (displyCheck === true) {
            //   ishidden = 0;
            // }
          }
        }
      }
    }
  }

  // ---------------------------

  // for (let index = 0; index < allConditionalFields.length; index++) {
  //   let item = allConditionalFields[index];
  //   let fName = item.name;
  //   let fKey = item.key;
  //   let options = item.options;
  //   let check = _.findIndex(options, (val) => {
  //     return val?.displayfields.indexOf(name) > -1;
  //   });
  //   // console.log("check---------- :- ", name, item);

  //   if (check >= 0) {
  //     // console.log("item :- ", name, item);
  //     let fieldsToDisplay = [];
  //     let fieldsToHide = [];

  //     if (formValues?.[fName]) {
  //       let selVal = formValues?.[`${fName}`];
  //       if (fKey === "dropdown") {
  //         let checkType = typeof formValues?.[`${fName}`];

  //         if (checkType === "object") {
  //           selVal = formValues?.[`${fName}`]?.value ?? "";
  //         }
  //       }
  //       // console.log("selected val :- ", selVal, item);

  //       // Get all unique conditional fields of this options.
  //       let allUniqueFields = [];
  //       _.map(options, (obj) => {
  //         let split = obj?.displayfields ? obj?.displayfields?.split(",") : [];
  //         allUniqueFields = _.concat(allUniqueFields, split);
  //       });
  //       allUniqueFields = _.uniq(allUniqueFields);

  //       if (fKey === "checkboxes") {
  //         // For selected option related child that we need to display
  //         _.map(selVal, (val) => {
  //           let matchR = _.filter(options, (o) => o?.value === val);
  //           if (matchR.length > 0) {
  //             let split = matchR?.[0]?.displayfields
  //               ? matchR?.[0]?.displayfields?.split(",")
  //               : [];
  //             fieldsToDisplay = _.concat(fieldsToDisplay, split);
  //           }
  //         });
  //         fieldsToDisplay = _.uniq(fieldsToDisplay);

  //         // For selected field other option related child that we need to hide
  //         fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
  //       } else {
  //         // For selected option related child that we need to display
  //         let matchR = _.filter(options, (o) => {
  //           return o.value === selVal;
  //         });

  //         if (matchR.length > 0) {
  //           let split = matchR?.[0]?.displayfields
  //             ? matchR?.[0]?.displayfields?.split(",")
  //             : [];
  //           fieldsToDisplay = split;
  //           fieldsToDisplay = _.uniq(fieldsToDisplay);
  //         }

  //         // For selected field other option related child that we need to hide
  //         fieldsToHide = _.difference(allUniqueFields, fieldsToDisplay);
  //       }

  //       console.log("fieldsToHide :- ", fName, fieldsToHide);
  //       // Clear the selected field's other options field data
  //       if (fieldsToHide.length > 0 && lastFieldUpdated === fName) {
  //         fieldsToHide.forEach((f) => {
  //           if (formValues?.[f]) {
  //             // console.log("in........ clear");
  //             clearFormFields(f, autofill); // Clear the child fields
  //           }

  //           // Check this field has conditional fields or not
  //           let match = _.filter(allConditionalFields, (obj) => {
  //             return obj.name === f;
  //           });

  //           if (match.length > 0) {
  //             clearReleatedFields(
  //               f,
  //               fieldsToDisplay,
  //               allConditionalFields,
  //               formValues,
  //               autofill,
  //               sectionArray,
  //               steps,
  //               updatedProgress
  //             ); // Call function to clear its child data
  //           }

  //           // Check if this is section field. then clear its all child elements and hide the section
  //           let checksection = _.filter(
  //             sectionArray,
  //             (section) => section?.name === f
  //           );
  //           // console.log("checksection :- ", f, checksection);

  //           if (checksection?.length > 0) {
  //             clearSectionFields(
  //               f,
  //               fieldsToDisplay,
  //               allConditionalFields,
  //               formValues,
  //               autofill,
  //               sectionArray,
  //               steps,
  //               updatedProgress
  //             );
  //           }
  //         });
  //       }

  //       console.log("fieldsToDisplay :- ", fName, fieldsToDisplay);
  //       // Display the selected field option field data
  //       if (fieldsToDisplay.length > 0) {
  //         let displyCheck = fieldsToDisplay.indexOf(name) >= 0;

  //         // Call this method to update the display section redux
  //         displaySection(fieldsToDisplay, steps, updatedProgress);

  //         if (displyCheck === true) {
  //           ishidden = 0;
  //         } else {
  //           ishidden = 1;
  //         }
  //       } else {
  //         ishidden = 1;
  //       }
  //     } else {
  //       ishidden = 1;
  //     }

  //     if (ishidden === 0) {
  //       // console.log("break called...........................", name);

  //       break;
  //     }
  //   }

  //   // else {
  //   //   // This else condition is only for section wise page display
  //   //   if (formValues?.[name]) {
  //   //     console.log("formvalue ---------- :- ", name, formValues?.[name]);

  //   //     let check = _.filter(allConditionalFields, (val) => {
  //   //       return val?.name === name;
  //   //     });
  //   //     console.log("check :- ", check);
  //   //     if (check?.length > 0) {
  //   //       let item = check[0];
  //   //       let fName = item.name;
  //   //       let fKey = item.key;
  //   //       let options = item.options;
  //   //     }
  //   //   }
  //   // }
  // }

  return ishidden;
};
